export default __webpack_public_path__ + "static/media/bg-mobile.b710b90d.png";